export default __webpack_public_path__ + "static/media/material-filter-list.e7f28b7f.svg";